import React from "react";
import { useI18n } from "../i18n";

export function LiveBadge({ live, size = "sm" }) {
  const { t } = useI18n();
  if (live) {
    return (
      <div className="flex items-center gap-2" data-testid="live-badge-online">
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-neon-green opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-neon-green"></span>
        </span>
        <span className="text-neon-green text-xs font-bold uppercase tracking-wider">{t("city.online")}</span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid="live-badge-offline">
      <span className="h-3 w-3 rounded-full bg-zinc-600"></span>
      <span className="text-zinc-500 text-xs font-bold uppercase tracking-wider">{t("store.offlineB")}</span>
    </div>
  );
}
